import { useQueryClient } from '@tanstack/react-query';

import { BrandProfilePayload } from 'domains/brand/types';
import QueryKeys from 'hooks/queries/keys';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

const useUpdateBrandProfile = () => {
    const queryClient = useQueryClient();

    return useMutation<BrandProfilePayload>(
        MutationKeys.UPDATE_BRAND_PROFILE,
        CuredApiPaths.BRAND_PROFILE,
        {
            onSuccess: () => {
                queryClient.invalidateQueries(QueryKeys.BRAND_PROFILE);
            },
        },
        ApiMethods.PUT
    );
};

export default useUpdateBrandProfile;
